import React, { useState } from 'react';
import api from '../services/api';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    empresa: '',
    servico: 'ecommerce',
    orcamento: 'ate-5000',
    mensagem: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await api.createMessage(formData);
      if (response.message) {
        setSubmitted(true);
        setFormData({
          nome: '',
          email: '',
          telefone: '',
          empresa: '',
          servico: 'ecommerce',
          orcamento: 'ate-5000',
          mensagem: ''
        });
        setTimeout(() => setSubmitted(false), 5000);
      } else {
        setError('Erro ao enviar mensagem. Tente novamente.');
      }
    } catch (err) {
      setError('Erro de conexão. Verifique sua internet.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="container">
        {/* Header da página */}
        <div className="contact-header">
          <span className="badge">✦ Vamos criar algo incrível</span>
          <h1>Solicite um <span className="hero-gradient">orçamento</span></h1>
          <p>Preencha o formulário abaixo e entraremos em contato em até 24h.</p>
        </div>

        <div className="contact-wrapper">
          {/* Formulário */}
          <div className="contact-form-container">
            {submitted ? (
              <div className="success-message">
                <i className="fas fa-check-circle"></i>
                <h3>Mensagem enviada com sucesso!</h3>
                <p>Em breve nossa equipe entrará em contato.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact-form">
                {error && (
                  <div className="error-message" style={{background: '#fee', color: '#c00', padding: '12px', borderRadius: '12px', marginBottom: '16px'}}>
                    <i className="fas fa-exclamation-triangle"></i> {error}
                  </div>
                )}
                <div className="form-row">
                  <div className="form-group">
                    <label><i className="fas fa-user"></i> Nome completo *</label>
                    <input
                      type="text"
                      name="nome"
                      value={formData.nome}
                      onChange={handleChange}
                      required
                      placeholder="Seu nome"
                    />
                  </div>
                  <div className="form-group">
                    <label><i className="fas fa-envelope"></i> E-mail *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="seu@email.com"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label><i className="fas fa-phone"></i> Telefone</label>
                    <input
                      type="tel"
                      name="telefone"
                      value={formData.telefone}
                      onChange={handleChange}
                      placeholder="(11) 99999-9999"
                    />
                  </div>
                  <div className="form-group">
                    <label><i className="fas fa-building"></i> Empresa</label>
                    <input
                      type="text"
                      name="empresa"
                      value={formData.empresa}
                      onChange={handleChange}
                      placeholder="Sua empresa"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label><i className="fas fa-code"></i> Tipo de serviço *</label>
                    <select name="servico" value={formData.servico} onChange={handleChange} required>
                      <option value="ecommerce">E-commerce</option>
                      <option value="portfolio">Portfólio / Site institucional</option>
                      <option value="webapp">Web App / Sistema</option>
                      <option value="landing">Landing Page</option>
                      <option value="outro">Outro</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label><i className="fas fa-chart-line"></i> Faixa de orçamento</label>
                    <select name="orcamento" value={formData.orcamento} onChange={handleChange}>
                      <option value="ate-5000">Até R$ 5.000</option>
                      <option value="5000-10000">R$ 5.000 - R$ 10.000</option>
                      <option value="10000-20000">R$ 10.000 - R$ 20.000</option>
                      <option value="20000-50000">R$ 20.000 - R$ 50.000</option>
                      <option value="acima-50000">Acima de R$ 50.000</option>
                    </select>
                  </div>
                </div>

                <div className="form-group full-width">
                  <label><i className="fas fa-comment"></i> Mensagem *</label>
                  <textarea
                    name="mensagem"
                    value={formData.mensagem}
                    onChange={handleChange}
                    required
                    rows="5"
                    placeholder="Conte-nos sobre seu projeto, ideias e necessidades..."
                  ></textarea>
                </div>

                <button type="submit" className="btn-submit" disabled={loading}>
                  {loading ? (
                    <><i className="fas fa-spinner fa-pulse"></i> Enviando...</>
                  ) : (
                    <>Enviar orçamento <i className="fas fa-arrow-right"></i></>
                  )}
                </button>
              </form>
            )}
          </div>

          {/* Informações de contato */}
          <div className="contact-info">
            <div className="info-card">
              <div className="info-icon">
                <i className="fas fa-envelope-open-text"></i>
              </div>
              <h3>E-mail</h3>
              <p>survows@gmail.com</p>
            </div>

            <div className="info-card">
              <div className="info-icon">
                <i className="fas fa-phone-alt"></i>
              </div>
              <h3>Telefone / WhatsApp</h3>
              <p>Indisponível no momento.</p>
            </div>

            <div className="info-card">
              <div className="info-icon">
                <i className="fas fa-clock"></i>
              </div>
              <h3>Atendimento</h3>
              <p>Segunda a Sexta: 9h às 18h</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
